<!--
 * @Author: 史金波
 * @Date: 2021-12-14 09:04:18
 * @LastEditors: 史金波
 * @Description: 
 * @LastEditTime: 2021-12-15 02:41:40
 * @FilePath: \saas-perform\src\views\system\user.vue
-->
/**
 * 系统管理 用户管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.userName" placeholder="输入用户名"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.mobile" placeholder="输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="状态">
			  <el-select size="small" v-model="formInline.status" placeholder="状态">
          <el-option label="全部" value=""></el-option>
          <el-option label="可用" value="1"></el-option>
          <el-option label="不可用" value="2"></el-option>
			  </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="getData()">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="addUser()">添加</el-button>
      </el-form-item>
    </el-form>
   
    
    <!-- 编辑界面 -->
    <el-table size="small" :data="users" highlight-current-row v-loading="loading" border element-loading-text="加载中" style="width: 50%;">
		  <el-table-column sortable prop="id" label="用户编号" width="200">
		  </el-table-column>
			<el-table-column sortable prop="userName" label="姓名" width="150">
			</el-table-column>
			<el-table-column sortable prop="mobile" label="手机号" width="150">
			</el-table-column>
			<el-table-column sortable prop="statusDesc" label="状态" width="150">
			</el-table-column>
      <el-table-column sortable prop="createDate" label="创建时间" width="150">
			</el-table-column>
		</el-table>
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>



    <el-dialog title="添加用户" :visible.sync="userAddVistor" width="30%" >
      <el-form :inline="false" :model="userCreateForm" class="user-search">
        <el-form-item label="用户名" prop="userName">
        <el-input size="small" v-model="userCreateForm.userName" auto-complete="off" placeholder="姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
        <el-input size="small" v-model="userCreateForm.mobile" auto-complete="off" placeholder="手机号"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="linkman">
        <el-input size="small" v-model="userCreateForm.userPwd" type="password" auto-complete="off" placeholder="密码"></el-input>
        </el-form-item>
        <el-button size="small" type="primary" class="title" @click="saveUser()">保存</el-button>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '../../components/Pagination'
import {userSearchApi,saveUserINfoApi} from '../../api/user/userApi'
export default {
  data(){
    return {
      userAddVistor:false,
      loading: false,
      formInline:{
      },
      users:[],
      pageparm: {
        currentPage: 1,
        pageSize: 15,
        total: 0
      },
      userCreateForm:{
        userName:'',
        mobile:'',
        userPwd:'',
      }
    }
  },
  methods:{
    getData(){
      userSearchApi({
          userName:this.formInline.userName,
          mobile:this.formInline.mobile,
          status:this.formInline.status,
          page: this.pageparm.currentPage,
					pageSize: this.pageparm.pageSize,
      }).then(res=>{
        console.log(res.data)
        this.users = res.data.data.list
        this.pageparm.total = res.data.data.total
      })
    },
    addUser(){
        this.userAddVistor = true
    },
    callFather: function(parm){
      this.pageparm.currentPage = parm.currentPage
      this.pageparm.pageSize = parm.pageSize
      this.getData()
    },
    saveUser(){
      saveUserINfoApi(this.userCreateForm).then(res=>{
        getData()
      })
    }
  },
  created(){
    this.getData()
  },
  components: {
		  Pagination
  },
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 


// WEBPACK FOOTER //
// src/views/system/user.vue